import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["value", "size"]
const _hoisted_2 = ["name", "value"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_v_icon = _resolveComponent("v-icon")

  return (_openBlock(), _createElementBlock("form", {
    ref: "form",
    class: "qty-picker mt-6 flex w-80 items-center justify-between rounded-4 border border-black-300 text-center text-12",
    onSubmit: _cache[3] || (_cache[3] = _withModifiers((...args) => (_ctx.debouncedUpdateQuantity && _ctx.debouncedUpdateQuantity(...args)), ["prevent"]))
  }, [
    _createElementVNode("button", {
      name: "add",
      class: "h-full px-8 py-[0.8125rem] hover:bg-black-200",
      onClick: _cache[0] || (_cache[0] = (...args) => ($options.decrement && $options.decrement(...args)))
    }, [
      _createVNode(_component_v_icon, {
        icon: "minus",
        width: 10,
        height: 2
      })
    ]),
    _createElementVNode("input", {
      value: $data.quantity,
      class: "py-4 text-center font-medium",
      onkeypress: "return event.charCode >= 48 && event.charCode <= 57",
      size: $options.inputSizeAttribute,
      onInput: _cache[1] || (_cache[1] = (...args) => ($options.update && $options.update(...args)))
    }, null, 40, _hoisted_1),
    _createElementVNode("button", {
      name: "add",
      class: "h-full px-8 py-[0.5625rem] hover:bg-black-200",
      onClick: _cache[2] || (_cache[2] = (...args) => ($options.increment && $options.increment(...args)))
    }, [
      _createVNode(_component_v_icon, {
        icon: "plus",
        width: 10,
        height: 10
      })
    ]),
    _createElementVNode("input", {
      type: "hidden",
      name: `updates[${$props.product.key}]`,
      value: $data.quantity
    }, null, 8, _hoisted_2)
  ], 544))
}